module.exports = __webpack_public_path__ + "static/media/lenovo.53001e54.svg";